module.exports = __webpack_public_path__ + "img/wifi-slash.d85da2fb.svg";